import { mapValues } from 'lodash';
import { LocaleSpecification, RelativeTimeSpec } from 'moment';

export const overrides = {
  s: 'Just now',
  ss: '<1m',
  m: '1m',
  mm: '%dm',
  h: '1h',
  hh: '%dh',
  d: '1d',
  dd: '%dd',
  M: '1mo',
  MM: '%dmo',
  y: '1y',
  yy: '%dy',
};

type Overrides = typeof overrides;

const format = (
  value: number,
  withoutSuffix: boolean | null,
  key: keyof Overrides,
  isFuture: boolean,
) => {
  const text = overrides[key].replace('%d', value.toString());

  if (withoutSuffix || text === overrides.s) {
    return text;
  }
  const pattern = isFuture ? 'in %s' : '%s ago';

  return pattern.replace('%s', text);
};

export const localeData: LocaleSpecification = {
  relativeTime: {
    future: '%s',
    past: '%s',
    ...mapValues(overrides, () => format),
  } as RelativeTimeSpec,
};
